import React from "react";

const WorkflowSection = ({ content, title, subtitle }) => (
  <div className="section is-small">
    <h3 className="title is-3">{title}</h3>
    <h4 className="subtitle is-5">{subtitle}</h4>
    <div className="container">
      <div className="columns is-multiline">
        {content.map(column => (
          <div className="column">
            {/* Column Heading */}
            <div style={columnStyles.stepNumber}>
              <span>{column.step}</span>
            </div>
            <h2 className="title is-4 has-text-centered">{column.title}</h2>
            <hr style={{ backgroundColor: "#c93e4e" }} />

            {/* Container for Tags/Steps */}
            <div id="tag-container" style={columnStyles.tagContainer}>
              {column.tags.map((tag, index) => (
                <span id="tag-arrow-wrapper">
                  <span className="tag is-brand" style={columnStyles.tag}>
                    {tag}
                  </span>

                  {/* Tags/Steps */}
                  {index < column.tags.length - 1 && (
                    <span id="arrow wrapper">
                      <div style={columnStyles.arrowBody} />
                      <div style={columnStyles.arrowHead} />
                    </span>
                  )}
                </span>
              ))}

              {/* Captions/Copy */}
              {column.content.map(paragraph => (
                <p style={{ marginTop: "2rem" }}>{paragraph}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const columnStyles = {
  stepNumber: {
    alignItems: "center",
    backgroundColor: "#c93e4e",
    color: "#fff",
    borderRadius: "50%",
    display: "flex",
    flexShrink: "1",
    fontSize: "3rem",
    fontWeight: "800",
    height: "6rem",
    justifyContent: "center",
    margin: "0 auto 1rem auto",
    width: "6rem"
  },
  tagContainer: {
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "space-between",
    height: "auto"
  },
  tag: {
    width: "100%",
    flexShrink: "2",
    borderRadius: "20px",
    color: "#fff",
    fontWeight: "600",
    fontSize: "1.2rem",
    textAlign: "center",
    marginBottom: "0"
  },
  arrowBody: {
    maxHeight: "60px",
    minHeight: "10px",
    flexGrow: "1",
    width: "8px",
    margin: "0 auto",
    background: "#000"
  },
  arrowHead: {
    margin: "0 auto",
    width: "0",
    height: "0",
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderTop: "10px solid #000"
  }
};

export default WorkflowSection;



// WEBPACK FOOTER //
// ./src/pages/Workflow/WorkflowSection.js